
import React from "react";

function OurServices() {
  return (
    <>
     <section id="services" >
        <div className="container">
          <div className="text-center mb-5">
            <span className="section-subtitle">OUR SERVICES</span>

            <h2 className="section-title">
              Comprehensive Healthcare Services
            </h2>

            <p
              className="section-text mx-auto"
              style={{ maxWidth: "700px" }}
            >
              We provide complete healthcare solutions using advanced medical
              technology and experienced specialists dedicated to delivering
              exceptional patient care.
            </p>
          </div>

          <div className="row g-4">
            {[
              {
                icon: "bi-heart-pulse-fill",
                title: "Primary Care",
                text: "Nephrologists are medical doctors who specialize in diagnosing and managing kidney disease, including monitoring how other chronic conditions such as diabetes and high blood pressure affect the kidneys.",
              },
              {
                icon: "bi-heart-fill",
                title: "General Nephrology",
                text: "General nephrology is a medical specialty focused on diagnosing and treating kidney conditions, including chronic kidney disease, high blood pressure, and electrolyte disorders.",
              },
              {
                icon: "bi-hospital-fill",
                title: "Emergency Care",
                text: "Immediate emergency treatment available around the clock for critical situations.",
              },
              {
                icon: "bi-capsule-pill",
                title: "Pharmacy",
                text: "Convenient in-house pharmacy with trusted medications and expert consultation.",
              },
              {
                icon: "bi-activity",
                title: "Diagnostics",
                text: "Accurate laboratory testing and imaging using advanced diagnostic technology.",
              },
              {
                icon: "bi-person-hearts",
                title: "Women's Health",
                text: "Comprehensive healthcare services dedicated to women's health and wellness.",
              },
              {
                icon: "bi-bandaid-fill",
                title: "Orthopedics",
                text: "Specialized care for bones, joints, muscles, and sports injuries.",
              },
              {
                icon: "bi-camera-video-fill",
                title: "Telemedicine",
                text: "Secure online consultations with experienced doctors from anywhere.",
              },
            ].map((service, index) => (
              <div className="col-lg-3 col-md-6" key={index}>
                <div className="service-card">
                  <div className="service-icon">
                    <i className={`bi ${service.icon}`}></i>
                  </div>

                  <h4>{service.title}</h4>

                  <p>{service.text}</p>

                  <a href="#contact">
                    Learn More <i className="bi bi-arrow-right"></i>
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default OurServices;
